import React from 'react'
import { Typography } from 'antd';

const { Title } = Typography;

const titleStyle = {
    color: "white",
    margin:"80px"
}

function Schedule() {
  return (
    <div>
        <Title level={1} style={titleStyle}>Schedule</Title>
    </div>
  )
}

export default Schedule